import * as React from 'react';
import { useSelector } from 'react-redux';
import { DeveloperDescription } from '../../../../DeveloperDescription';
import { AboutBlockLayout } from '../AboutBlockLayout';
import { getDeveloperDescription } from '../../../../../selectors/developerV2';

export const AboutDeveloper: React.FC = () => {
  const description = useSelector(getDeveloperDescription);

  return <AboutBlockLayout title="О застройщике" content={<DeveloperDescription description={description} />} />;
};
